import { CheckBadgeIcon, TableCellsIcon, TicketIcon } from "@heroicons/react/24/outline";
import { HTMLAttributes, forwardRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetSettings } from "src/api/General/settings";
import { getAnalyticsTabKey, getTimeTrackingTabKey } from "src/utils/filters";
import { cn } from "src/utils/ui/ui";

export default function TimeTracking() {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState<
    "timesheets" | "entries" | "approvals"
  >(
    (localStorage.getItem(getTimeTrackingTabKey()) as
      | "timesheets"
      | "entries"
      | "approvals") || "timesheets"
  );
  const { data: settings } = useGetSettings();

  useEffect(() => {
    localStorage.setItem(getAnalyticsTabKey(), selectedTab);
  }, [selectedTab]);

  // useEffect(() => {
  //   if (!tab) {
  //     navigate(`/time-tracking/timesheets`);
  //   }
  // }, [tab]);

  return (
    <div className="flex h-full flex-col overflow-auto">
      <div className="flex h-12 shrink-0 items-center border-b border-gray-200/70 px-8 text-sm text-gray-800">
        <div className="flex items-center space-x-2 text-sm">
          <div className="cursor-default text-gray-800">{"Time Tracking"}</div>
        </div>
      </div>
      <div className="grid p-6 gap-4 px-8 sm:grid-cols-2 lg:grid-cols-4">
        <AnalyticsCard
          onClick={() => {
            navigate("/time-tracking/timesheets");
          }}
        >
          <div className="flex items-center space-x-1.5">
            <TableCellsIcon className="text-primary-500 h-[18px] w-[18px]" />
            <div className="text-lg font-medium leading-none text-gray-800">
              Timesheets
            </div>
          </div>
          <div className="pt-2 text-sm font-light text-gray-600">
            View and submit timesheets.
          </div>
        </AnalyticsCard>
        {/* <AnalyticsCard
          onClick={() => {
            navigate("/time-tracking/timesheet-approvals");
          }}
        >
          <div className="flex items-center space-x-1.5">
            <CheckBadgeIcon className="text-primary-500 h-[18px] w-[18px]" />
            <div className="text-lg font-medium leading-none text-gray-800">
              Timesheet Approvals
            </div>
          </div>
          <div className="pt-2 text-sm font-light text-gray-600">
            View and approve timesheets.
          </div>
        </AnalyticsCard> */}
        <AnalyticsCard
          onClick={() => {
            navigate("/time-tracking/entries");
          }}
        >
          <div className="flex items-center space-x-1.5">
            <TicketIcon className="text-primary-500 h-[18px] w-[18px]" />
            <div className="text-lg font-medium leading-none text-gray-800">
              Entries
            </div>
          </div>
          <div className="pt-2 text-sm font-light text-gray-600">
            View and analyze entries.
          </div>
        </AnalyticsCard>
      </div>
    </div>
  );
}

type AnalyticsTabProps = {
  // route: string;
  name: string;
  Icon: React.ReactNode;
  selected: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const AnalyticsTab = forwardRef<HTMLDivElement, AnalyticsTabProps>(
  ({ children, className, Icon, name, selected, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(
          "flex h-12 cursor-pointer items-center justify-start space-x-2 border-b border-gray-200/70 px-8 text-sm hover:bg-gray-50",
          selected ? "bg-gray-100/70 text-gray-800" : "text-gray-700",
          className
        )}
      >
        {Icon}
        <div>{name}</div>
      </div>
      //   <div
      //     ref={ref}
      //     {...props}
      //     className={cn(
      //       "flex h-12 cursor-pointer items-center justify-start space-x-2 border-b border-gray-200/70 px-8 text-sm hover:bg-gray-50",
      //       className
      //     )}
      //   >
      //     {children}
      //   </div>
      //   <div className="flex h-12 cursor-pointer items-center justify-start space-x-2 border-b border-gray-200/70 px-8 text-sm hover:bg-gray-50">
      //   <StopwatchIcon className="h-4 w-4" />
      //   <div>Time Tracking</div>
      // </div>
    );
  }
);

type CardProps = {} & HTMLAttributes<HTMLDivElement>;

export const AnalyticsCard = forwardRef<HTMLDivElement, CardProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(
          "h-30 cursor-pointer rounded-lg border border-gray-200/70 p-6 shadow-sm hover:bg-gray-50",
          className
        )}
      >
        {children}
      </div>
    );
  }
);

function TimesheetsTab() {
  const navigate = useNavigate();
  return <div className="grid p-6 px-8 md:grid-cols-3"></div>;
}

function TemplatesAnalyticsTabs() {
  const navigate = useNavigate();
  return (
    <div className="grid p-6 px-8 md:grid-cols-3">
      <AnalyticsCard
        onClick={() => {
          navigate("/analytics/project-template-performance");
        }}
      >
        <div className="flex items-center space-x-1.5">
          {/* <MapIcon className="text-primary-500 h-[18px] w-[18px]" /> */}
          <div className="text-lg font-medium leading-none text-gray-800">
            Project Template Performance
          </div>
        </div>
        <div className="pt-2 text-sm font-light text-gray-600">
          View the performance of your project templates.
        </div>
      </AnalyticsCard>
    </div>
  );
}

function TimeTrackingAnalyticsTabs() {
  const navigate = useNavigate();
  return (
    <div className="grid gap-4 p-6 px-8 md:grid-cols-3">
      <AnalyticsCard
        onClick={() => {
          navigate("/analytics/utilization");
        }}
      >
        <div className="flex items-center space-x-1.5">
          {/* <MapIcon className="text-primary-500 h-[18px] w-[18px]" /> */}
          <div className="text-lg font-medium leading-none text-gray-800">
            Utilization Trend
          </div>
        </div>
        <div className="pt-2 text-sm font-light text-gray-600">
          View how your team's utilization is trending by day, week, month or
          quarter.
        </div>
      </AnalyticsCard>
      <AnalyticsCard
        onClick={() => {
          navigate("/analytics/utilization-deepdive");
        }}
      >
        <div className="flex items-center space-x-1.5">
          {/* <MapIcon className="text-primary-500 h-[18px] w-[18px]" /> */}
          <div className="text-lg font-medium leading-none text-gray-800">
            Utilization Breakdown
          </div>
        </div>
        <div className="pt-2 text-sm font-light text-gray-600">
          View your team's utilization relative to their capacity and allocated
          time.
        </div>
      </AnalyticsCard>
      <AnalyticsCard
        onClick={() => {
          navigate("/analytics/timesheet-submissions");
        }}
      >
        <div className="flex items-center space-x-1.5">
          <div className="text-lg font-medium leading-none text-gray-800">
            Timesheet Submissions
          </div>
        </div>
        <div className="pt-2 text-sm font-light text-gray-600">
          See how many timesheets have been submitted by your team.
        </div>
      </AnalyticsCard>
    </div>
  );
}
